import React from 'react';
import { Box, Typography, IconButton, useTheme } from '@mui/material';
import { faFilter, faPlus } from '@fortawesome/sharp-regular-svg-icons';
import { FaOptionIcon } from '@europrocurement/l2d-icons';

type ActivityFilter = 'all' | 'notes' | 'important_notes' | 'actions';

export type EmptyStateProps = {
    currentFilter: ActivityFilter;
    onCreateNote: () => void;
    onFilterClick: (event: React.MouseEvent<HTMLElement>) => void;
};

export const EmptyState: React.FunctionComponent<EmptyStateProps> = function ({
    currentFilter,
    onCreateNote,
    onFilterClick,
}) {
    const theme = useTheme();

    const getEmptyStateMessage = () => {
        if (currentFilter === 'all') return "Pas d'activités";
        if (currentFilter === 'notes') return 'Pas de notes';
        if (currentFilter === 'important_notes') return 'Pas de notes importantes';
        return "Pas d'actions";
    };

    return (
        <Box
            sx={{
                border: '1px dashed',
                borderColor: 'divider',
                borderRadius: '8px',
                padding: '12px',
                minHeight: '55px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '8px',
            }}
        >
            <Typography
                variant="l2dbodyxs"
                sx={{ color: 'text.secondary', textAlign: 'center' }}
            >
                {getEmptyStateMessage()}
            </Typography>
            <Box sx={{ display: 'flex', gap: '8px' }}>
                <IconButton
                    size="small"
                    onClick={onCreateNote}
                    sx={{
                        padding: '4px',
                        color: 'text.secondary',
                        '&:hover': { color: theme.palette.primary.main },
                    }}
                    title="Créer une note"
                >
                    <FaOptionIcon
                        icon={faPlus}
                        sx={{ fontSize: '12px' }}
                    />
                </IconButton>
                <IconButton
                    size="small"
                    onClick={onFilterClick}
                    sx={{
                        padding: '2px',
                        color:
                            currentFilter !== 'all' ? theme.palette.primary.main : 'text.secondary',
                        '&:hover': { color: theme.palette.primary.main },
                    }}
                    title="Filtres"
                >
                    <FaOptionIcon
                        icon={faFilter}
                        sx={{ fontSize: '10px' }}
                    />
                </IconButton>
            </Box>
        </Box>
    );
};
